import styled from "@emotion/styled";
import { Colors, Spacing } from "@snapchat/snap-design-system";

export const LensDestinationsDivider = styled.div`
    width: 100%;
    height: 1px;
    margin-top: 4px;
    margin-bottom: ${Spacing["2XS"]}px;

    opacity: 0.2;
    background: ${Colors.WHITE};
`;
